// src/config.js
// Single place for environment-driven URLs and role routing.

export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.taxbooth.app";

export const MARKETING_URL =
  process.env.REACT_APP_MARKETING_URL || "https://taxbooth.app";

// where each role lands after login
export const HOME_PATH = {
  admin: "/admin",
  practitioner: "/practitioner",
  user: "/app",
};

export const homePathForRole = (role) => HOME_PATH[role] || "/app";

// practitioners do not self-register; point them at the enquiry form
export const ENQUIRY_URL = `${MARKETING_URL}/contact`;

// EFT banking details for manual upgrades (v1). Set these via REACT_APP_* env.
export const BANK = {
  accountName: process.env.REACT_APP_BANK_NAME || "CodeBooth (Pty) Ltd",
  bank: process.env.REACT_APP_BANK_BANK || "Nedbank",
  accountNumber: process.env.REACT_APP_BANK_ACCOUNT || "1335675647",
  branchCode: process.env.REACT_APP_BANK_BRANCH || "198765",
  accountType: process.env.REACT_APP_BANK_TYPE || "Cheque",
  payEmail: process.env.REACT_APP_BANK_EMAIL || "hello@codebooth.co.za",
};